export const environment_core = {
    webApiUrl: '#{AwsWebsite.AdminisApiUrl}',
    loginFeUrl: '#{AwsWebsite.LoginFeUrl}',
    loginApiUrl: '#{AwsWebsite.LoginApiUrl}',
    loginApiUrlBase: '#{LoginApi.BaseUrl}',
    loginApiCognitoUrl: '#{LoginApi.BaseUrl}/aws-cognito-auth/exchange-authorization',
    redirectUrlSso: '#{AwsWebsite.RedirectUrlSso}',
};
